// Type guard for filtering undefined values
export const isNotUndefined = <T>(value: T | undefined): value is T =>
  value !== undefined && value !== null;
